import React, { createContext, FC, useContext } from 'react';

import * as Types from '../types';

export const SlideOutContext = createContext<Types.Context | undefined>(undefined);

export const SlideOutProvider: FC<React.PropsWithChildren<{ value?: Types.Context }>> = ({ children, value }) => {
  return <SlideOutContext.Provider value={value}>{children}</SlideOutContext.Provider>;
};

export const useSlideOutContext = () => {
  const context = useContext(SlideOutContext);

  if (context === undefined) {
    throw new Error('useSlideOutContext must be used within a SlideOutProvider');
  }

  return context;
};
